import styled from "styled-components";
import {StyledBaseProps} from "@betrue/shared/interfaces";
import React, {useState} from "react";
import {Badge, Fab} from "@material-ui/core";
import {ChatModalProps} from "@betrue/ui";
import CloseIcon from "@material-ui/icons/Close";
import ChatBubbleOutlineRoundedIcon from '@material-ui/icons/ChatBubbleOutlineRounded';
import OpenInNewRoundedIcon from '@material-ui/icons/OpenInNewRounded';

export interface ChatModalViewProps extends StyledBaseProps, ChatModalProps {
  notificationCount: number
  landing?: string
}

export const ChatModalView = styled((props: ChatModalViewProps) => {
  const [open, setOpen] = useState<boolean>(props.landing ? true : props.openByDefault === "true")


  return (
    <div className={props.className}>
      <div className={'bt-frame-modal'} style={{visibility: open ? "visible" : "hidden"}}>
        <iframe allow="camera; microphone; display-capture; autoplay; clipboard-write"
                src={props.landing ? `https://chat.betrue.fr${props.landing}` : `https://chat.betrue.fr/channel/${props.landingChannel ? props.landingChannel : 'theoffice'}`}
                allowFullScreen={true}>
        </iframe>
        <a target={'_blank'} href="https://chat.betrue.fr"> <OpenInNewRoundedIcon></OpenInNewRoundedIcon></a>
      </div>

      <Badge className={'bt-chat-button'} badgeContent={props.notificationCount} color="secondary">
        <Fab onClick={() => setOpen(!open)} aria-label={'fab.label'} color={'primary'}>
          {open ? (<CloseIcon/>) : (<ChatBubbleOutlineRoundedIcon/>)}
        </Fab>
      </Badge>

    </div>
  )
})`
  & {
    @media (max-width: 600px) {
      .bt-frame-modal {
        z-index: 2000;
        min-height: cal(90% - 80px) !important;
        width: 100% !important;;
        position: fixed;
        bottom: 80px;
        left: 0px !important;
        top: 0px !important;
        right: 0px !important;
      }
    }

    .bt-frame-modal {
      z-index: 2000;
      min-height: ${props => props.chatWindowHeight ? props.chatWindowHeight : '650px'};
      width: ${props => props.chatWindowWidth ? props.chatWindowWidth : '400px'};
      position: fixed;
      bottom: 80px;
      left: 16px;

      a {
        position: absolute;
        right: 0;
        z-index: 50;
        float: right;
      }

      iframe {
        border: solid 1px ${props => props.theme.colors.accent};

        background-color: transparent;
        position: absolute;
        height: 100%;
        width: 100%;
      }
    }

    .bt-chat-button {
      z-index: 100;
      position: fixed;
      bottom: 16px;
      left: 16px;
    }
  }`
